import React, { useMemo } from "react";

import VStack from "../../../ui_atoms/VStack";
import PayrollBreakdownHourlyInfo from "./PayrollBreakdownHourlyInfo";
import Gap from "../../../ui_atoms/Gap";
import PayrollBreakdownTotalInfo from "./PayrollBreakdownTotalInfo";
import { PayrollBreakdownViewerProps } from "./PayrollBreakdownDetails";
import {
    PayrollBreakdownStatus,
    PayrollSourceType,
    TimeSheetState,
} from "../../../__generated__/graphql";
import PayrollBreakdownAbsences from "./PayrollBreakdownAbsenses";

const PayrollBreakdownHourly: React.FC<PayrollBreakdownViewerProps> = ({
    payrollBreakdown,
    vacationStatus,
}) => {
    const allCompleted =
        payrollBreakdown?.timesheets?.length &&
        payrollBreakdown?.timesheets?.every(
            (ts) => ts.status === TimeSheetState.Submitted || ts.status === TimeSheetState.Accepted,
        );

    const displayInfo = useMemo(() => {
        return (
            // a paid décompte has been submitted before
            payrollBreakdown.status !== PayrollBreakdownStatus.Open ||
            (payrollBreakdown.missionInfo.payrollSource === PayrollSourceType.Lift && allCompleted)
        );
    }, [allCompleted, payrollBreakdown]);
    return (
        <VStack>
            <VStack h="2/3">
                <PayrollBreakdownHourlyInfo
                    payrollBreakdown={payrollBreakdown}
                    disabled={!displayInfo}
                />
                <Gap gap={0.25} />
                <PayrollBreakdownTotalInfo
                    payrollBreakdown={payrollBreakdown}
                    vacationStatus={vacationStatus}
                    disabled={!displayInfo}
                />
            </VStack>
            <PayrollBreakdownAbsences absences={payrollBreakdown.absences} />
        </VStack>
    );
};

export default PayrollBreakdownHourly;
